import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { isEmpty } from 'lodash';

export const useShouldDisplayTable = () => {
  const location = useLocation();
  return useMemo(() => !isEmpty(location.search), [location]);
};
